import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white border-t border-line py-14 px-4" data-id="element-129">
      <div className="max-w-4xl mx-auto text-center" data-id="element-130">
        <div className="text-rose font-bold tracking-[0.18em] text-xs mb-3 uppercase" data-id="element-131">
          🌸 Aula Mater™
        </div>
        <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink mb-4 uppercase tracking-tight" data-id="element-132">
          Aula Mater
        </h3>
        <p className="text-ink-soft max-w-2xl mx-auto text-sm md:text-base leading-relaxed mb-8" data-id="element-133">
          Contenido educativo y herramientas prácticas para mejorar tu bienestar
          emocional. Porque proteger tu paz mental no debería postergarse por
          falta de un método claro y aplicable.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-10 text-sm text-ink" data-id="element-134">
          <span className="flex items-center gap-2" data-id="element-135">
            📧{' '}
            <span className="font-medium select-all" data-id="element-136">
              soporteaulamater@gmail.com
            </span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-137">|</span>
          <span className="flex items-center gap-2" data-id="element-138">
            📲 Instagram:{' '}
            <span className="font-medium select-all" data-id="element-139">@aulamater_</span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-140">|</span>
          <span className="flex items-center gap-2" data-id="element-141">
            📘 Facebook:{' '}
            <span className="font-medium select-all" data-id="element-142">Aula Mater</span>
          </span>
        </div>

        <div className="border-t border-line pt-6 text-xs text-muted leading-relaxed max-w-2xl mx-auto" data-id="element-143">
          © {new Date().getFullYear()} Aula Mater™ — Todos los derechos
          reservados. Prohibida la reproducción y redistribución sin
          autorización expresa. Este material tiene fines informativos y de
          bienestar personal. No reemplaza el diagnóstico ni el tratamiento
          profesional.
        </div>
        <div className="font-serif-italic text-rose text-base mt-6" data-id="element-144">
          🌸 "Tu paz mental también merece protección."
        </div>
      </div>
    </footer>;
}